export const EmailTemplateTypes = {
  GRID: "email_template_grid",
  COLLAGE: "email_template_collage",
  CUSTOM_SIZE: "email_template_custom_size"
};
